import {useState, useEffect} from 'react';
import {Box, Container} from "@mui/material";
import Grid from "@mui/material/Grid";

// page components
import QuickRechargeForm from "../components/QuickRechargeForm";
import OfferCard from "../components/OfferCard";
import AdditionalInfo from "../components/AdditionalInfo";
import FeatureInfo from "../components/FeatureInfo";
import TheWidget from "../components/TheWidget";
import {IsRtl, MediaQueryCheck, GetError} from "../customHook/useGlobal";
import AlertMessage from "../components/ui/AlertMessage";



export default function QuickRechargeLanding() {

    const isScreenSmall = MediaQueryCheck("sm")
    const isScreenMedium = MediaQueryCheck("md")

    const isRtl = IsRtl()

    const [errState, setErrState] = useState()
    const formErrorHandler = (err) => {
        setErrState(err)
    };

    // Showing postback errors after Credit Card processing
    let search = window.location.search
    let params = new URLSearchParams(search)
    useEffect(() => {
        if (params.get('status') && params.get('status') == '720') {
            GetError('720-PAYMENTAFTERSTEPUP', (error) => {
                setErrState(error)
            })
        }
        if(params.get('status') && params.get('status') != '720') {
            GetError('500-GENERIC_ERROR', (error) => {
                setErrState(error)
            })
        }
    },[])

    return (
        <>
            <Container disableGutters maxWidth="lg">
                <Box sx={{p: {xs: "20px 0 0", md: "40px 108px"} }}>
                    {errState &&
                        <>
                            <AlertMessage {...{alertType:"error", alertTitle: "",  alertMessage: isRtl ? errState["error_ar"] : errState["error_en"]}} />
                            <Box sx={{minHeight:"40px"}} />
                        </>
                    }
                    <Grid container justifyContent={isScreenMedium && "space-between"} >
                        <Grid item xs={12} md={5}>
                            <QuickRechargeForm formErrorHandler={formErrorHandler} />
                            <Box sx={{width:"340px"}}>
                                <TheWidget {...{widgetName:"cardsacceptPrepaid"}} />
                            </Box>
                        </Grid>
                        <Grid item md="auto" sx={{mt: isScreenSmall && 3, mb: isScreenSmall && 10, px: isScreenSmall && 5 }}>
                            <OfferCard {...{offerType:"recharge"}} />
                        </Grid>
                    </Grid>
                </Box>
            </Container>
            <AdditionalInfo />
            <FeatureInfo />
        </>
    )
}